import { files } from "@/fireinit.js";
import Vue from "vue";
import axios from "axios";

export default {
  loadOrders: async ({ commit, rootState }) => {
    let orders = await axios.get(`${rootState.axios.API}orders`, {
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    commit("setOrders", orders.data);
  },
  saveOrder: async ({ commit, rootState, dispatch }, payload) => {
    let returnData = {};
    await axios
      .post(`${rootState.axios.API}orders/update`, payload, {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      })
      .then((response) => {
        returnData = response;
        returnData["Result"] = "Success";
        dispatch("loadOrders");
      })
      .catch((err) => {
        returnData = err;
        returnData["Result"] = "Failed";
      });
    return returnData;
  },
  submitForm: async ({ commit, rootState }, payload) => {
    let returnData = {};
    await axios
      .post(`${rootState.axios.API}giftBoxSubmitForm`, payload)
      .then((response) => {
        returnData = response.data;
      })
      .catch((err) => {
        returnData = err;
      });
    return returnData;
  },

  makePayment: async ({ commit, rootState }, payload) => {
    let returnData = {};
    await axios
      .post(`${rootState.axios.API}buyGiftBox`, payload)
      .then((response) => {
        returnData = response.data;
      })
      .catch((err) => {
        returnData = err;
      });
    return returnData;
  },
};
